<template>
  <div class="d-flex align-center">
    <div class="per-page-select" :tabindex="tabindex" @blur="open = false">
      <div class="selected mr-2" :class="{ open: open , 'selected--light': !isDarkMode }" @click="open = !open">
        {{ selected }}
      </div>
      <div class="items" :class="{ selectHide: !open, 'items--light': !isDarkMode }">
        <div
          v-for="(option, i) of options"
          :key="i"
          @click="
            selected = option;
            open = false;
            $emit('input', option);
          "
        >
          {{ option }}
        </div>

      </div>
    </div>
    <span class="per-page-select__desc">{{ perPageDesc }}</span>
  </div>
</template>

<script>
export default {
  name: "PerPageSelect",
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    perPageDesc: {
      type: String,
      default: "items"
    }
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options.length > 0
        ? this.options[0]
        : null,
      open: false,
    };
  },
  mounted() {
    this.$emit("input", this.selected);
  },
  computed: {
    isDarkMode() {
      return this.$store.state.mode.darkMode
    }
  }
};
</script>

<style lang="scss" scoped>
.per-page-select {
  font-size: 14px;
  position: relative;
  width: 48px;
  margin-right: 8px;
  text-align: left;
  outline: none;
  height: 32px;
  line-height: 32px;

  &__desc {
    font-size: var(--font-small-size);
    @media screen and (max-width: 768px) {
      font-size: var(--font-tiny-size);
    }
  }
}

.per-page-select .selected {
  border-radius: 6px;
  border: 1px solid #d2d4e5;
  padding-left: 0.5em;
  cursor: pointer;
  user-select: none;
  width: 48px;

  &--light {
    background-color: white;
    color: var(--apio-shade-2);
  }
}

.per-page-select .selected.open {
  border: 1px solid #29b6f6;
  border-bottom-color: #d2d4e5;
  border-radius: 6px 6px 0px 0px;
}

.per-page-select .selected:after {
  position: absolute;
  content: "";
  top: 15px;
  right: 0.5rem;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #d2d4e5 transparent transparent transparent;
}

.per-page-select .items {
  border-radius: 0 0px 6px 6px;
  overflow: hidden;
  background: var(--apio-shade-2);
  color: white;
  border-right: 1px solid #29b6f6;
  border-left: 1px solid #29b6f6;
  border-bottom: 1px solid #29b6f6;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  line-height: 1.5;

  &--light {
    background-color: white;
    color: var(--apio-shade-2);
  }
}

.per-page-select .items div {
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.per-page-select .items div:hover {
  background-color: grey;
  color: white;
}

.selectHide {
  display: none;
}
</style>
